import * as d3 from 'd3'
export default {

  methods: {

    gauge_Delta() {

      let delta = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.circle.cx},${this.circle.cy})`)

      // Actual Cumulative Progress
      delta
      .append('text')
      .attr('transform', `translate(0, ${-41 + this.title.total.tSize*0.36})`)
      .attr('font-size', this.title.total.tSize).attr('fill', this.title.total.tColor)
      .attr('text-anchor', this.title.total.align)
      .text(this.title.delta.name)

      let value = delta
      .append('g')
      .attr('id', `DELTA_${this.localId}`)
      .attr('transform', `translate(0, -50)`)

      let col = this.columns.find(f=> f.code == 'DELTA')
      value // Progress
      .append('text')
      .attr('id', `DT_VAL_${this.localId}`)
      .attr('x', 0).attr('y', 0)
      .attr('font-size', col.tSize).attr('fill', this.gmx_deltaValue(this.rawData[col.code]))
      .text(this.rawData[col.code])

      let x_ = this.getNode(`#DT_VAL_${this.localId}`, 'width')
      
      value // Aarow
      .append('path')
      .attr('transform', `translate(${x_}, -9) scale(.7)`)
      .attr('d', this.gmx_deltaValue(this.rawData[col.code], 'icon'))
      .attr('fill', this.gmx_deltaValue(this.rawData[col.code]))
      .attr('stroke-width', .5)

      d3.select(`#DELTA_${this.localId}`)
      .attr('transform', `translate(${-(this.getNode(`#DELTA_${this.localId}`, 'width')/2)}, -50)`)

    },

  }
}